import React, { useState } from 'react'
import { ImEye, ImEyeBlocked } from 'react-icons/im'
import CopyToClip from '../../infra/CopyToClip'
import HiddenPass from './HiddenPass'
import VisiblePass from './VisiblePass'
import './SignUpOption.css'

export default function NewPasswd({passwd}) {  
  const [show, setShow] = useState(false);

  const passComp = show ? <VisiblePass passwd={passwd}/> : <HiddenPass/>;
  const eyeComp = show ? <div className='hisEyesAreClosed'>
                            <ImEyeBlocked/>
                        </div> 
                        : 
                        <div className='hisEyesAreOpen'><ImEye /></div>
                        ;

  const handleShow = () => {
    setShow(curShow => !curShow);
  }  

  // TODO: Add "Login" option on signup response message.
  const doLogin = () => {

  }

  return (
    <div className='newPasswd'>      
      <div style={{color: 'orangered'}}>Please Copy Your Initial Password:</div>
      <div className='eyePass'>
        <div>
          <div onClick={handleShow}>{eyeComp}</div>
          <CopyToClip text={passwd} />
        </div>
        <div className='passBox'>
          {passComp}
        </div>
      </div>      
      {/* <div>
          <div className='signUpButton' onClick={doLogin}>OK, Sign me in!</div>
        </div> */}
    </div>
  )
}
